var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main-content"},[_c('card',{attrs:{"title":"采购","tabs":_vm.cat.buy_bstatus,"body-class":"page-card-body"},on:{"change":_vm.statusChange},model:{value:(_vm.business_status),callback:function ($$v) {_vm.business_status=$$v},expression:"business_status"}},[_c('purchase-list',{ref:"purchaseList"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }